import React, { useState } from "react";
import PlFlag from "../../images/poland.png";
import EnFlag from "../../images/united-kingdom.png";
import { Link } from "react-router-dom";
import {
  SideBarContainer,
  Icon,
  CloseIcon,
  SideBarLink,
  SideBarWrapper,
  SideBarMenu,
  UpArrow,
  SideBtnWrapper,
  ImageButton1,
  ImageButton2,
} from "./SideBarElementsEN";
import { Button } from "../ButtonElement";

const SideBarEN = ({ isOpen, toggle }) => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };
  return (
    <SideBarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SideBarWrapper>
        <SideBarMenu>
          <SideBarLink
            to="aboutEN"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            offset={-80}
          >
            About Us
          </SideBarLink>
          <SideBarLink
            to="offerEN"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            offset={-80}
          >
            Offer
          </SideBarLink>
          <SideBarLink
            to="contactEN"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            offset={-80}
          >
            Contact
          </SideBarLink>
        </SideBarMenu>
        <SideBtnWrapper>
          <Button
            to="startEN"
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            onClick={toggle}
            primary="true"
            dark="true"
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            offset={-65}
          >
            <UpArrow />
          </Button>
        </SideBtnWrapper>
        <SideBtnWrapper>
          <Link to="/">
            <ImageButton1 src={PlFlag} type="image/png" />
          </Link>
          <Link to="/en">
            <ImageButton2 src={EnFlag} type="image/png" />
          </Link>
        </SideBtnWrapper>
      </SideBarWrapper>
    </SideBarContainer>
  );
};

export default SideBarEN;
